function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useEffect, useState } from 'react';
import { set } from 'mobx';
import FooterComponent from './FooterComponent';
import FoldOutComponent from './FoldOutComponent';
var SectionComponent = function SectionComponent(_ref) {
  var settings = _ref.settings,
    footerData = _ref.footerData;
  var _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    videoIframe = _useState2[0],
    setvideoIframe = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showFoldOut = _useState4[0],
    setShowFoldout = _useState4[1];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    sectionHtml = _useState6[0],
    setSectionHtml = _useState6[1];
  var _useState7 = useState(Date.now()),
    _useState8 = _slicedToArray(_useState7, 2),
    randomNumber = _useState8[0],
    setRandomNumber = _useState8[1];
  useEffect(function () {
    var preSectionData = {
      headlines: '',
      texts: [],
      image: ''
    };
    settings.preElementItems.map(function (item) {
      if (item.type === 'image' && !item.tag) {
        preSectionData.image = item.html.html;
      }
      if (item.type === 'text') {
        if (item.html.html.indexOf('<h2') > -1) {
          preSectionData.headlines = item.html.html;
        } else {
          preSectionData.texts.push(item.html.html);
        }
      }
      if (item.type === 'image' && item.tag === 'mobileImage') {
        preSectionData.mobileImage = item.html.html;
      }
      if (item.type === 'video') {
        setvideoIframe(item.html.html);
      }
    });
    setSectionHtml(preSectionData);
  }, [settings]);
  var onDiscoverMore = function onDiscoverMore() {
    setShowFoldout(!showFoldOut);
  };
  var isMobile = window.innerWidth < 600;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "section-container"
  }, sectionHtml && /*#__PURE__*/React.createElement("div", {
    className: "section-container__headline headlines",
    dangerouslySetInnerHTML: {
      __html: sectionHtml.headlines
    }
  }), sectionHtml && /*#__PURE__*/React.createElement("div", {
    className: "section-container__content"
  }, sectionHtml.texts[0] && /*#__PURE__*/React.createElement("div", {
    className: "section-container__content__column__text",
    dangerouslySetInnerHTML: {
      __html: sectionHtml.texts[0]
    }
  }), isMobile && sectionHtml.mobileImage ? sectionHtml.mobileImage && /*#__PURE__*/React.createElement("div", {
    className: "section-container__content__column__image",
    dangerouslySetInnerHTML: {
      __html: sectionHtml.mobileImage
    }
  }) : sectionHtml.image && /*#__PURE__*/React.createElement("div", {
    className: "section-container__content__column__image",
    dangerouslySetInnerHTML: {
      __html: sectionHtml.image
    }
  }), sectionHtml.texts[1] && /*#__PURE__*/React.createElement("div", {
    className: "section-container__content__column__text",
    dangerouslySetInnerHTML: {
      __html: sectionHtml.texts[1]
    }
  })), /*#__PURE__*/React.createElement(FooterComponent, {
    footerData: footerData,
    videoIframe: videoIframe,
    onDiscoverMore: onDiscoverMore,
    isFoldOut: showFoldOut,
    randomNumber: randomNumber,
    isFoldOutContent: settings.elements.length > 0
  })), /*#__PURE__*/React.createElement(FoldOutComponent, {
    elements: settings.elements,
    show: showFoldOut,
    randomNumber: randomNumber,
    onDiscoverMore: onDiscoverMore,
    footerData: footerData[0]
  }));
};
export default SectionComponent;